import React, { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import Layout from "../../components/Layout.js";

import Select from "react-select";
import { apiFetch } from "../../api.js";

const BankMasterDetailsDesign = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const allowAlphabets = (value) => value.replace(/[^a-zA-Z ]/g, "");
  const allowNumbers = (value) => value.replace(/[^0-9]/g, "");
  const [entryDate, setEntryDate] = useState("");
  const [Bankname, setBankName] = useState("");
  const [Accountno, setAccountno] = useState("");
  const [Accountname, setAccountname] = useState("");
  const [Abbreviation, setAbbreviation] = useState("");
  const [Type, setType] = useState("");
  const [isEditMode, setIsEditMode] = useState(false);
  const [Accountnamelist, setAccountnamelist] = useState([]);
  const [typelist, settypelist] = useState([]);
  const [ipAddress, setIpAddress] = useState("");
  const [userId, setUserId] = useState("");
  const [serverIp] = useState(window.location.hostname);
  const storedUserInfo = JSON.parse(sessionStorage.getItem("userinfo")) || {};
  const [screenWidth, setScreenWidth] = useState(window.innerWidth);

  useEffect(() => {
    const handleResize = () => setScreenWidth(window.innerWidth);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const accountNameOptions = Accountnamelist.map((a) => ({
    value: a.value,
    label: a.value,
  }));

  const typeOptions = typelist.map((t) => ({
    value: t.data,
    label: t.data,
  }));
  const customStyles = {
    control: (base) => ({
      ...base,
      minHeight: "42px",
      borderRadius: "4px",
      borderColor: "#ccc",
    }),
  };

  useEffect(() => {
    const fetchDropdowns = async () => {
      try {
        const [accRes, typeRes] = await Promise.all([
          apiFetch("/api/bankmaster/accountnames"),
          apiFetch("/api/bankmaster/type"),
        ]);

        const accData = await accRes.json();
        const typeData = await typeRes.json();

        if (Array.isArray(accData)) setAccountnamelist(accData);
        if (Array.isArray(typeData)) settypelist(typeData);
      } catch (err) {
        console.error("❌ Error fetching dropdowns:", err);
      }
    };

    fetchDropdowns();
  }, []);

  function formatDateForInput(dateStr) {
    if (!dateStr) return "";
    const [day, month, year] = dateStr.split("-");
    return `${year}-${month}-${day}`;
  }
  useEffect(() => {
    if (location.state?.editData) {
      const data = location.state.editData;

      setEntryDate(data.entrydate || "");
      setBankName(data.bankname || "");
      setAccountno(data.accountno || "");
      setAccountname(data.accountname || "");
      setAbbreviation(data.abbreviation || "");
      setType(data.type || "");
      setIsEditMode(true);
    } else {
      setIsEditMode(false);
    }
  }, [location.state]);

  useEffect(() => {
    apiFetch("/api/get-ip")
      .then((res) => res.json())
      .then((data) => setIpAddress(data.ip))
      .catch(() => setIpAddress("0.0.0.0"));
  }, []);

  useEffect(() => {
    const storedUserInfo = JSON.parse(sessionStorage.getItem("userinfo")) || {};
    setUserId(storedUserInfo.userId || "");
  }, []);
  /*------------------- Styles--------------*/
  const pageContainerStyle = {
    width: "100%",
    minHeight: "100vh",
    backgroundColor: "#f4f6f8",
    display: "flex",
    justifyContent: "center",
    alignItems: "flex-start",
    padding: "10px",
    boxSizing: "border-box",
  };
  const containerStyle = {
    width: "100%",
    maxWidth: "1400px",
    padding: "16px",
    borderRadius: "8px",
    backgroundColor: "#fff",
    boxSizing: "border-box",
  };

  const headerStyle = {
    border: "2px solid #8B1E3F",
    borderRadius: "6px",
    padding: "15px",
    marginBottom: "20px",
    textAlign: "center",
    background: "#8B1E3F",
    fontWeight: "bold",
    fontSize: "1.5rem",
    color: "#fff",
  };
  const rowStyle = {
    display: "grid",
    gap: "16px",
    marginBottom: "16px",
    width: "100%",
    gridTemplateColumns: "1fr", // mobile default
  };

  const responsiveRowStyle = {
    ...rowStyle,
    gridTemplateColumns:
      screenWidth >= 1200
        ? "repeat(4, 1fr)" // 💻 desktop
        : screenWidth >= 768
          ? "repeat(2, 1fr)" // 📲 tablet
          : "1fr", // 📱 mobile
  };

  const columnStyle = { display: "flex", flexDirection: "column" };
  const inputStyle = {
    padding: "10px",
    marginTop: "5px",
    borderRadius: "4px",
    border: "1px solid #ccc",
    width: "100%",
    boxSizing: "border-box",
  };
  const buttonContainerStyle = {
    display: "flex",
    justifyContent: "center",
    flexWrap: "wrap",
    gap: "12px",
    marginTop: "20px",
    position: "relative",
    zIndex: 10,
  };

  const buttonStyle = (bgColor) => ({
    minWidth: "110px", // 👈 fixed small size
    maxWidth: "140px",
    padding: "10px 16px",
    backgroundColor: bgColor,
    color: "#fff",
    border: "none",
    borderRadius: "6px",
    cursor: "pointer",
    textAlign: "center",
    fontWeight: "bold",
    whiteSpace: "nowrap", // 👈 prevents text break
  });

  const labelStyle = { fontWeight: "bold", marginBottom: "5px" };

  const handleSave = async () => {
    if (!entryDate || !Bankname || !Accountno || !Accountname || !Type) {
      alert("⚠️ Please fill all required fields.");
      return;
    }

    const payload = {
      entryDate,
      userId,
      ipAddress,
      serverIp,
      Bankname: Bankname.trim(),
      Accountno: Accountno.trim(),
      Accountname: Accountname.trim(),
      Abbreviation: Abbreviation || "",
      Type,
      what: "insert",
      id: null,
    };

    try {
      const response = await apiFetch(
        "/api/bankmaster/insert",
        {
          method: "POST",
          body: JSON.stringify(payload),
        },
      );

      if (!response.ok) {
        const err = await response.text();
        console.error("SAVE ERROR:", err);
        alert("Save failed!");
        return;
      }

      const result = await response.json();

      if (result?.success) {
        alert("✅ Saved successfully!");
        navigate("/Bank/grid");
      } else {
        alert("❌ " + (result?.error || result?.message || "Save failed"));
      }
    } catch (err) {
      console.error("❌ SAVE ERROR:", err);
      alert("❌ Network / Server error");
    }
  };

  const handleUpdate = async () => {
    if (!entryDate || !Bankname || !Accountno || !Accountname || !Type) {
      alert("⚠️ Please fill all required fields.");
      return;
    }

    const recordId = location.state?.editData?.uniqueid;

    if (!recordId) {
      alert("❌ Record ID missing. Cannot update.");
      return;
    }

    const payload = {
      entryDate,
      Bankname: Bankname.trim().toUpperCase(),
      Accountno: Accountno.trim().toUpperCase(),
      Accountname: Accountname.trim().toUpperCase(),
      Abbreviation: Abbreviation.trim(),
      Type: Type.trim(),
      what: "update",
      id: recordId,
    };

    try {
      const response = await apiFetch(
        "/api/bankmaster/insert",
        {
          // ✅ FIX URL
          method: "POST",
          body: JSON.stringify(payload),
        },
      );

      // ✅ RESPONSE CHECK
      if (!response.ok) {
        const errText = await response.text();
        console.error("UPDATE ERROR:", errText);
        alert("Update failed!");
        return;
      }

      const result = await response.json();

      // ✅ SAFE MESSAGE HANDLING
      if (result?.message === "Update successfully") {
        alert("✅ Record updated successfully!");
        navigate("/Bank/grid");
      } else if (result?.message === "E01: Duplicate Entry") {
        alert("❌ Duplicate bank name detected!");
      } else {
        alert("⚠️ " + (result?.message || "Unknown response"));
      }
    } catch (err) {
      console.error("❌ Error updating record:", err);
      alert("❌ Failed to update! Please try again.");
    }
  };
  const handleExit = () => {
    navigate("/Bank/grid");
  };

  return (
    <Layout>
      <div style={pageContainerStyle}>
        <div style={containerStyle}>
          <div style={headerStyle}>Bank Master</div>
          <div style={responsiveRowStyle}>
            <div style={columnStyle}>
              <label style={labelStyle}>Date</label>
              <input
                type="date"
                value={entryDate}
                onChange={(e) => setEntryDate(e.target.value)}
                style={inputStyle}
              />
            </div>
            <div style={columnStyle}>
              <label style={labelStyle}>Bank Name</label>
              <input
                type="text"
                value={Bankname}
                onChange={(e) => setBankName(allowAlphabets(e.target.value))}
                style={inputStyle}
              />
            </div>

            <div style={columnStyle}>
              <label style={labelStyle}>Account No</label>
              <input
                type="text"
                value={Accountno}
                onChange={(e) => setAccountno(allowNumbers(e.target.value))}
                style={inputStyle}
              />
            </div>

            <div style={columnStyle}>
              <label style={labelStyle}>Account Name</label>
              <Select
                options={accountNameOptions}
                value={
                  accountNameOptions.find((o) => o.value === Accountname) ||
                  null
                }
                onChange={(selected) => setAccountname(selected?.value || "")}
                styles={customStyles}
                placeholder="Select Account Name"
                isSearchable
              />
            </div>

            <div style={columnStyle}>
              <label style={labelStyle}>Abbreviation</label>
              <input
                type="text"
                value={Abbreviation}
                onChange={(e) =>
                  setAbbreviation(allowAlphabets(e.target.value))
                }
                style={inputStyle}
              />
            </div>

            <div style={columnStyle}>
              <label style={labelStyle}>Type</label>
              <Select
                options={typeOptions}
                value={typeOptions.find((o) => o.value === Type) || null}
                onChange={(selected) => setType(selected?.value || "")}
                styles={customStyles}
                placeholder="Select Type"
                isSearchable
              />
            </div>
          </div>

          <div style={buttonContainerStyle}>
            {!isEditMode && (
              <button style={buttonStyle("#4caf50")} onClick={handleSave}>
                Save
              </button>
            )}
            {isEditMode && (
              <button style={buttonStyle("#2e20abff")} onClick={handleUpdate}>
                Update
              </button>
            )}
            <button style={buttonStyle("#ab2025")} onClick={handleExit}>
              Exit
            </button>
          </div>
        </div>
      </div>
    </Layout>
  );
};

export default BankMasterDetailsDesign;
